export default class {
	constructor(items, onChange) {
		this.items = items;
		this.onChange = onChange;
	}
	
	prev() {
		const index = this._getIndex();
		this._activateByIndex(index - 1);
	}

	next() {
		const index = this._getIndex();
		this._activateByIndex(index + 1);
	}

	getItemProxies() {
		return this.items.map((itm) => {
			return {
				props: itm,
				activate: () => this._activateItem(itm)
			};
		});
	}
	
	_getIndex() {
		let index = -1;
		this.items.forEach((itm, idx) => index = itm.active ? idx : index);
		return index;
	}
	
	_activateByIndex(index) {
		const selectedIndex = this._mod(index, this.items.length);
		this.items.forEach((itm, idx) => itm.active = (idx === selectedIndex));
        this.onChange();
	}

	_activateItem(item) {
        this.items.forEach(itm => itm.active = false);
        if(item) {
        	item.active = true;
		}
        this.onChange();
	}
	
	_mod(n, m) {
		return (n % m + m) % m;
	}
}
